module.exports = __webpack_public_path__ + "img/37_11.823285ad.png";